export const iconFontAwesomeSportsFitnessFireFlameSimple = (
	<i className="fa-solid fa-fire-flame-simple"></i>
);
